import React from "react";
import { LeadLink } from "web/react/components/lead-link";
import { Text } from "web/react/emo/text/text";
import { AffiliateBuyButton } from "web/react/pages/product/in-stock/in-stock-product-page/buy-button/";
import { gettext } from "web/script/modules/django-i18n";
import { ProductBuyOptionsSerializer } from "web/types/serializers";
import * as styles from "./express-checkout-disclaimer.css";

interface ExpressCheckoutDisclaimerProps {
    productId: string;
    buyOption: ProductBuyOptionsSerializer;
}

interface ExpressCheckoutBuyOptionProps {
    buyOption: ProductBuyOptionsSerializer;
}

interface ExpressCheckoutLeadLinkProps extends ExpressCheckoutBuyOptionProps {
    productId: string;
}

export function ExpressCheckoutBuyDirectButton({
    buyOption,
}: ExpressCheckoutBuyOptionProps): JSX.Element {
    return (
        <AffiliateBuyButton
            buttonProps={{
                title: gettext("product.buy_area.buy_direct_btn_text"),
                variant: "secondary",
            }}
            buyOption={buyOption}
            contextType={"comparison_option"}
        />
    );
}

export function ExpressCheckoutOrSeparator(): JSX.Element {
    return (
        <Text as={"span"} className={styles.or} textStyle={"caption-1"}>
            {gettext("in_stock_product.or_separator")}
        </Text>
    );
}

export function ExpressCheckoutLeadLink({
    productId,
    buyOption,
}: ExpressCheckoutLeadLinkProps): JSX.Element {
    return (
        <LeadLink
            href={buyOption.affiliate_url}
            productId={productId}
            openInNewTab={true}
            reason="retailer-ec-disclaimer"
        >
            <Text as={"span"} textStyle={"body-s-bold"}>
                <span className={styles.copy}>
                    {gettext("product.buy_area.size_stock_disclaimer", {})}
                </span>
                {buyOption.retailer_name}
            </Text>
        </LeadLink>
    );
}

export function ExpressCheckoutDisclaimer({
    productId,
    buyOption,
}: ExpressCheckoutDisclaimerProps): JSX.Element {
    return <ExpressCheckoutLeadLink productId={productId} buyOption={buyOption} />;
}
